<template>
    <div>{{ time }}</div>
  </template>
  
  <script>
  export default {
    name: 'CountDown',
    props: {
      endTime: {
        type: Number,
        default: 0,
      }
    },
    data() {
      return {
        time: '00:00:00',
        interval: null
      };
    },
    methods: {
      startCountdown() {
        this.updateTime();
        this.interval = setInterval(this.updateTime, 1000);
      },
      updateTime() {
        const now = new Date();
        const distance = this.endTime - now;
  
        if (distance < 0) {
          clearInterval(this.interval);
          this.time = '00:00:00';
          return;
        }
  
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
        this.time = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
      },
      pad(num) {
        return num < 10 ? '0' + num : num;
      }
    },
    mounted() {
      this.startCountdown();
    },
    beforeDestroy() {
      clearInterval(this.interval);
    },
  };
  </script>
  